/**
 * 主题状态管理
 * 使用 Zustand 管理主题颜色和颜色模式（light/dark/system）
 */

import { create } from 'zustand'

import { STORAGE_KEYS } from '@/shared/constants/storage-keys'
import { storage } from '@/shared/lib/storage'
import { type Theme, type Mode } from '@/shared/types/theme'

interface ThemeState {
  theme: Theme          // 主题颜色（default/red/blue...）
  colorMode: Mode       // 颜色模式（light/dark/system）
  actions: {
    setTheme: (theme: Theme) => void
    setColorMode: (colorMode: Mode) => void
  }
}

export const useThemeStore = create<ThemeState>((set) => ({
  // 从 localStorage 初始化
  theme: (storage.getItem(STORAGE_KEYS.theme) as Theme) || 'default',
  colorMode: (storage.getItem(STORAGE_KEYS.colorMode) as Mode) || 'system',

  actions: {
    // 设置主题颜色
    setTheme: (theme: Theme) => {
      set({ theme })
      storage.setItem(STORAGE_KEYS.theme, theme)
    },
    // 设置颜色模式（light/dark/system）
    setColorMode: (colorMode: Mode) => {
      set({ colorMode })
      storage.setItem(STORAGE_KEYS.colorMode, colorMode)
    }
  }
}))

// 便捷的 Hooks 导出
export const useTheme = () => useThemeStore((state) => state.theme)
export const useColorMode = () => useThemeStore((state) => state.colorMode)
export const useThemeActions = () => useThemeStore((state) => state.actions)
